module.exports = __webpack_public_path__ + "img/moneybookers.461a2166.png";